import {Component, HostBinding, Input} from '@angular/core';
import {BlockElementGroup} from 'app/entities/blockElements/blockElementGroup';
import {TabsComponent} from '../../../ui/tabs/item';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';

@Component({
  selector: 'app-block-element-group',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementGroupComponent extends BlockElementAbstractComponent<BlockElementGroup> {
  tabsReady(tabs: TabsComponent) {
    tabs.updateHeight();
  }
}
